export enum SentryErrorLogMessages {
  GoogleRedirectFailed = "User sign up failed",
  UserFetchError = "Error while fetching user details",
  MicPermissionDenied = "Mic permission denied by browser",
  CameraPermissionDenied = "Camera permission denied by browser",
}
